import { AgreeAndContinueButton } from '../shared/buttons/AgreeAndContinueButton';
import { PayNowButton } from '../shared/buttons/PayNowButton';
import { useFormContext } from 'react-hook-form';
import { ContactInformationFormType } from '../../interface/checkoutInterface';
import { setPurchaseCompleted } from '../../redux/slices/commonSlice';
import { ComponentConfig } from '@measured/puck';
import LoadingSpinner from '../shared/LoadingSpinner';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import { AxiosInstance } from 'axios';
import CustomTooltip from '../../../components/common/tooltip';
import { ColorProps, colorField } from '../../puck/reusable-props/color';
import { MarginProps, marginFields } from '../../puck/reusable-props/margin';
import { WidthProps, widthField } from '../../puck/reusable-props/width';
import { PaddingProps, paddingFields } from '../../puck/reusable-props/padding';
import TextCustomInput from '../../puck/reusable-props/TextCustomInput';
import { CustomizeProps } from '../../interface/commonInterface';
import {
  getcurrentDeviceType,
  getMarginStyles,
  getQuillEditorText,
} from '../../utils/helper';
import { Switch } from '@mui/material';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { getIsViewIsEdit } from '../../utils/constants';
import { boxShadows } from '../../puck/reusable-props/options';
import WithAccordion from '../customComponents/CustomAccordion';
import ColorPicker from '../../puck/reusable-props/ColorPicker';
export type ConfirmPurchaseTCProps = {
  buttonConfig: {
    Selected: {
      Button: CustomizeProps;
      ButtonText: CustomizeProps;
    };
    UnSelected: {
      Button: CustomizeProps;
      ButtonText: CustomizeProps;
    };
    termsAndCon: {
      ErrorMessage: string;
      isLikeCheckBox: boolean;
      isAllowWithoutChecked: boolean;
      isThrowError: boolean;
      isAutoSelect: boolean;
    };
  };
  border: IBorderValueProps;
  borderBackground: {
    isInherit: boolean;
    bgcolor?: string;
  };
  boxShadow: 'none' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl';
} & ColorProps &
  MarginProps &
  PaddingProps &
  WidthProps;

export interface ConfirmPurchaseTCComponentProps
  extends ReduxSelectorProps,
    ReduxDispatchProps {
  baseService?: AxiosInstance;
}

export const ConfirmPurchaseTC = ({
  useAppDispatch,
  useAppSelector,
}: ConfirmPurchaseTCComponentProps): ComponentConfig<ConfirmPurchaseTCProps> => {
  return {
    label: (
      <CustomTooltip title="ConfirmPurchase">
        <span>Confirm Purchase T&C</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      buttonConfig: {
        type: 'custom',
        label: 'Button Title',
        render: ({ value, onChange, field }) => {
          return (
            <>
              <WithAccordion title="Button Configuration">
                <div>
                  If checkbox is <strong>unselected</strong> the button title
                  will be:
                </div>
                <TextCustomInput
                  key={1}
                  showHover={true}
                  value={value?.UnSelected?.Button}
                  onChange={newValue =>
                    onChange({
                      ...value,
                      UnSelected: { ...value?.UnSelected, Button: newValue },
                    })
                  }
                  isAccordion={false}
                  title={field?.label}
                  quillEditorId={1}
                  isDisableEditor={true}
                />
                <div>
                  If checkbox is <strong>unselected</strong> the button text
                  will be:
                </div>
                <TextCustomInput
                  key={2}
                  showHover={true}
                  value={value?.UnSelected?.ButtonText}
                  onChange={newValue =>
                    onChange({
                      ...value,
                      UnSelected: {
                        ...value?.UnSelected,
                        ButtonText: newValue,
                      },
                    })
                  }
                  isAccordion={false}
                  title={'Button Text'}
                  quillEditorId={2}
                  isDisableEditor={true}
                />
                <div className="py-4">
                  If checkbox is <strong>selected</strong> the button title will
                  be:
                </div>
                <TextCustomInput
                  key={3}
                  showHover={true}
                  value={value?.Selected?.Button}
                  onChange={newValue =>
                    onChange({
                      ...value,
                      Selected: { ...value.Selected, Button: newValue },
                    })
                  }
                  title={field?.label}
                  isAccordion={false}
                  quillEditorId={3}
                  isDisableEditor={true}
                />
                <div>
                  If checkbox is <strong>selected</strong> the button text will
                  be:
                </div>
                <TextCustomInput
                  key={4}
                  showHover={true}
                  value={value?.Selected?.ButtonText}
                  onChange={newValue =>
                    onChange({
                      ...value,
                      Selected: { ...value?.Selected, ButtonText: newValue },
                    })
                  }
                  isAccordion={false}
                  title={'Button Text'}
                  quillEditorId={4}
                  isDisableEditor={true}
                />

                <div className="py-4">
                  If checkbox is <strong>unselected</strong> and payment button
                  is clicked (only 1 can be selected):
                </div>

                <div className="flex gap-2 items-center justify-between">
                  <label>Switch status of checkbox to selected</label>
                  <Switch
                    checked={value?.termsAndCon?.isLikeCheckBox}
                    onChange={e =>
                      onChange({
                        ...value,
                        termsAndCon: {
                          ...value?.termsAndCon,
                          isLikeCheckBox: e.target.checked,
                          isAllowWithoutChecked: false,
                          isThrowError: false,
                          isAutoSelect: false,
                        },
                      })
                    }
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
                <div className="flex gap-2 items-center justify-between">
                  <label>Send error message</label>
                  <Switch
                    checked={value?.termsAndCon?.isThrowError}
                    onChange={e =>
                      onChange({
                        ...value,
                        termsAndCon: {
                          ...value?.termsAndCon,
                          isLikeCheckBox: false,
                          isAllowWithoutChecked: false,
                          isAutoSelect: false,
                          isThrowError: e.target.checked,
                        },
                      })
                    }
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
                {value?.termsAndCon?.isThrowError && (
                  <textarea
                    value={value?.termsAndCon?.ErrorMessage}
                    onChange={e =>
                      onChange({
                        ...value,
                        termsAndCon: {
                          ...value?.termsAndCon,
                          ErrorMessage: e.target.value,
                        },
                      })
                    }
                    placeholder="Terms and condition"
                    className="w-full border border-gray-300 rounded-md p-2 pagebuilder-theme"
                  />
                )}
                <div className="flex gap-2 items-center justify-between">
                  <label>Allow payment to be processed</label>
                  <Switch
                    checked={value?.termsAndCon?.isAllowWithoutChecked}
                    onChange={e =>
                      onChange({
                        ...value,
                        termsAndCon: {
                          ...value?.termsAndCon,
                          isLikeCheckBox: false,
                          isAllowWithoutChecked: e.target.checked,
                          isThrowError: false,
                          isAutoSelect: e.target.checked,
                        },
                      })
                    }
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
                {value?.termsAndCon?.isAllowWithoutChecked && (
                  <div className="flex gap-2 items-center justify-between">
                    <label>Auto select checkbox</label>
                    <Switch
                      checked={value?.termsAndCon?.isAutoSelect}
                      onChange={e =>
                        onChange({
                          ...value,
                          termsAndCon: {
                            ...value?.termsAndCon,
                            isAutoSelect: e.target.checked,
                          },
                        })
                      }
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </div>
                )}
              </WithAccordion>
            </>
          );
        },
      },

      ...colorField,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      borderBackground: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <WithAccordion title={'Border Background'}>
            <div className="flex justify-between items-center mb-3">
              <label>Inherit Parent</label>
              <Switch
                checked={value?.isInherit}
                onChange={e =>
                  onChange({
                    ...value,
                    isInherit: e.target.checked,
                  })
                }
              />
            </div>
            {!value?.isInherit && (
              <ColorPicker
                label="Background Color"
                tooltip="backgroundColor"
                onChange={bgcolor =>
                  onChange({
                    ...value,
                    bgcolor,
                    isInherit: value?.isInherit ?? false,
                  })
                }
                value={value?.bgcolor}
              />
            )}
          </WithAccordion>
        ),
      },
      boxShadow: {
        label: 'Shadow',
        type: 'select',
        options: boxShadows,
      },
      ...widthField,
    },
    defaultProps: {
      buttonConfig: {
        termsAndCon: {
          ErrorMessage: '*Please accept the terms and conditions to proceed.',
          isLikeCheckBox: false,
          isAllowWithoutChecked: false,
          isThrowError: false,
          isAutoSelect: false,
        },
        Selected: {
          Button: {
            weight: {
              mobile: 'font-bold',
              tablet: 'font-bold',
              desktop: 'font-bold',
            },
            deviceType: 'desktop',
            text: 'COMPLETE PURCHASE',
            textColor: {
              mobile: '#000000',
              tablet: '#000000',
              desktop: '#000000',
            },
            hoverColor: {
              mobile: '#000000',
              tablet: '#000000',
              desktop: '#000000',
            },
            fontSize: {
              mobile: 'text-xl',
              tablet: 'text-2xl',
              desktop: 'text-2xl',
            },
          },
          ButtonText: {
            weight: {
              mobile: 'font-normal',
              tablet: 'font-normal',
              desktop: 'font-normal',
            },
            deviceType: 'desktop',
            text: 'TRY IT RISK FREE! 30-DAY MONEY-BACK GUARANTEE!',
            textColor: {
              mobile: '#000000',
              tablet: '#000000',
              desktop: '#000000',
            },
            hoverColor: {
              mobile: '#000000',
              tablet: '#000000',
              desktop: '#000000',
            },
            fontSize: {
              mobile: 'text-sm',
              tablet: 'text-sm',
              desktop: 'text-sm',
            },
          },
        },

        UnSelected: {
          Button: {
            weight: {
              mobile: 'font-bold',
              tablet: 'font-bold',
              desktop: 'font-bold',
            },
            deviceType: 'desktop',
            text: 'AGREE & CONTINUE',
            textColor: {
              mobile: '#000000',
              tablet: '#000000',
              desktop: '#000000',
            },
            hoverColor: {
              mobile: '#000000',
              tablet: '#000000',
              desktop: '#000000',
            },
            fontSize: {
              mobile: 'text-xl',
              tablet: 'text-2xl',
              desktop: 'text-2xl',
            },
          },
          ButtonText: {
            weight: {
              mobile: 'font-normal',
              tablet: 'font-normal',
              desktop: 'font-normal',
            },
            deviceType: 'desktop',
            text: 'TRY IT RISK FREE! 30-DAY MONEY-BACK GUARANTEE!',
            textColor: {
              mobile: '#000000',
              tablet: '#000000',
              desktop: '#000000',
            },
            hoverColor: {
              mobile: '#000000',
              tablet: '#000000',
              desktop: '#000000',
            },
            fontSize: {
              mobile: 'text-sm',
              tablet: 'text-sm',
              desktop: 'text-sm',
            },
          },
        },
      },
      margin: {
        desktop: {
          top: '8',
          bottom: '4',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '8',
          bottom: '4',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '8',
          bottom: '4',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '4',
          mobile: '4',
          tablet: '4',
        },
        paddingLeft: {
          desktop: '4',
          mobile: '4',
          tablet: '4',
        },
        paddingRight: {
          desktop: '4',
          mobile: '4',
          tablet: '4',
        },
        paddingTop: {
          desktop: '4',
          mobile: '4',
          tablet: '4',
        },
      },
      width: 'w-full',
      boxShadow: 'none',
      ...borderProps,
      color: {
        backgroundColor: '#FFFFFF',
        hoverColor: '#FFFFFF',
      },
      borderBackground: {
        isInherit: false,
        bgcolor: '#FFFFFF',
      },
    },
    render: ({
      margin,
      color,
      border,
      width,
      padding,
      buttonConfig,
      boxShadow,
      editMode,
      borderBackground,
    }) => {
      const Selected = buttonConfig?.Selected;
      const UnSelected = buttonConfig?.UnSelected;
      const termsAndCon = buttonConfig?.termsAndCon;
      const navigate = useNavigate();
      const { pathname } = useLocation();
      const dispatch = useAppDispatch();
      const [termsError, setTermsError] = useState(false);
      const isTermsAccepted = useAppSelector(
        state => state.common.isTermsAccepted,
      );
      const { submitSuccess, purchaseCompleted } = useAppSelector(
        state => state.common,
      );
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const checkoutState = useAppSelector(state => state.checkout);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const { formState } = useFormContext<ContactInformationFormType>();
      const isEmpty = (obj: object) =>
        obj ? Object.keys(obj).length === 0 : true;
      const [searchParams] = useSearchParams();
      const newSearchParams = new URLSearchParams(searchParams.toString());
      const isSetShippingApiLoading = useAppSelector(
        state => state.checkout.isSetShippingApiLoading,
      );
      let navState = {};
      if (!getIsViewIsEdit() && checkoutState?.nextpageConfig?.id) {
        navState = {
          state: checkoutState?.nextpageConfig?.id
            ? {
                id: checkoutState?.nextpageConfig?.id,
                pageVisiblity: checkoutState?.nextpageConfig?.pageVisiblity,
                pageType: checkoutState?.nextpageConfig?.pageType,
              }
            : {},
        };
      }

      const state = useAppSelector(state => state);
      const isCartLoading = useAppSelector(state => state.cart.isCartLoading);
      const newButtonText = {
        ...Selected?.ButtonText,
        text: getQuillEditorText(Selected?.ButtonText?.text, state),
      };
      const newButton = {
        ...Selected?.Button,
        text: getQuillEditorText(Selected?.Button?.text, state),
      };
      const newUnSelectButton = {
        ...UnSelected?.Button,
        text: getQuillEditorText(UnSelected?.Button?.text, state),
      };
      const newUnSelectButtonText = {
        ...UnSelected?.ButtonText,
        text: getQuillEditorText(UnSelected?.ButtonText?.text, state),
      };
      useEffect(() => {
        if (purchaseCompleted) {
          navigate(pathname + '?' + newSearchParams.toString(), navState);
          dispatch(setPurchaseCompleted(false));
        }
      }, [purchaseCompleted]);
      const marginStyles = getMarginStyles(margin, currentDeviceType);

      return (
        <>
          <div
            style={{
              ...marginStyles,
              backgroundColor: borderBackground?.isInherit
                ? 'inherit'
                : borderBackground?.bgcolor,
            }}>
            <div
              className={`relative flex justify-center items-center ${boxShadow}`}
              style={{ margin: 0 }}>
              {!isTermsAccepted &&
              termsAndCon?.isLikeCheckBox &&
              !termsAndCon?.isThrowError &&
              !termsAndCon?.isAllowWithoutChecked ? (
                <AgreeAndContinueButton
                  useAppDispatch={useAppDispatch}
                  useAppSelector={useAppSelector}
                  showVip={true}
                  Button={newUnSelectButton}
                  ButtonText={newUnSelectButtonText}
                  currentDeviceType={currentDeviceType}
                  styles={{
                    backgroundColor: color?.backgroundColor,
                    hoverColor: color?.hoverColor,
                    border: border,
                    width: width,
                    padding: padding,
                  }}
                />
              ) : (
                <PayNowButton
                  useAppSelector={useAppSelector}
                  useAppDispatch={useAppDispatch}
                  showVip={true}
                  Button={isTermsAccepted ? newButton : newUnSelectButton}
                  isButton={
                    (termsAndCon?.isThrowError && !isTermsAccepted) ||
                    !isEmpty(formState?.errors)
                  }
                  isAutoselect={
                    termsAndCon?.isAutoSelect &&
                    termsAndCon?.isAllowWithoutChecked &&
                    !isTermsAccepted
                  }
                  setTermsError={setTermsError}
                  currentDeviceType={currentDeviceType}
                  ButtonText={
                    isTermsAccepted ? newButtonText : newUnSelectButtonText
                  }
                  styles={{
                    backgroundColor: color?.backgroundColor,
                    hoverColor: color?.hoverColor,
                    border: border,
                    width: width,
                    padding: padding,
                  }}
                />
              )}
              {(submitSuccess ||
                isCartLoading ||
                isSetShippingApiLoading > 0) && (
                <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-90">
                  <div className="h-9">
                    <LoadingSpinner />
                  </div>
                </div>
              )}
            </div>
          </div>
          {!isEmpty(formState?.errors) && (
            <div className="text-red-500 text-xs sm:text-right mt-1">
              * Please fix the errors mentioned above.
            </div>
          )}
          {termsAndCon?.isThrowError && !isTermsAccepted && termsError && (
            <div className="text-red-500 text-xs sm:text-right mt-1">
              {termsAndCon?.ErrorMessage}
            </div>
          )}
        </>
      );
    },
  };
};
